import Header from "../components/header";
import PricingHolder from '../components/pricing-holder';
import TextHolder from "../components/text-holder";
import { useEffect,useState } from "react";
import { fetchPaymentDetails } from "../functions/fetchPaymentDetails";

function PaymentPage(){
    const [details,SetDetails] = useState(null);
    useEffect(async() => {
        let details = await fetchPaymentDetails();
        SetDetails(details);
      }, []);
    return <>
    <Header URLForLogo='/'></Header>
    <TextHolder heading="Want to upgrade to a paid account?" smallText="Check our simple monthly and yearly pricing options, cancellable at any time!" />
    <PricingHolder subscription={true} details={details} />
    </>
}
    
export default PaymentPage;